<template>
    <div id="add-new-chat">
        <div class="material-icons close-add-user-page" @click="closeAddUserPage">close</div>
        <div class="selected-user-input row">
            <span style="display: contents">
                <span class="selected-user-item row" v-for="selectedMember in selectedMembers">
                    {{ selectedMember.name }}
                    <span class="material-icons closeIcon" @click="cancelSelectMember(selectedMember)"> cancel </span>
                </span>
                <a-input
                    :placeholder="$t('message.selectPeople')"
                    class="input-select"
                    v-model="searchValue"
                    name="search"
                >
                </a-input>
            </span>
            <span>
                <md-button
                    :key="'members' + selectedMembers.length"
                    @click="createChatOrAddUserGroup"
                    v-if="selectedMembers.length > 0"
                >
                    <span class="next-btn"
                        >{{ !!addUserInGroup ? $t("message.add") : $t("message.next")
                        }}<send-icon style="margin-left: 10px" />
                    </span>
                </md-button>
                <md-button disabled v-else>
                    <span class="next-btn-disabled">
                        {{ !!addUserInGroup ? $t("message.add") : $t("message.next") }}
                        <span class="material-icons" style="margin-left: 5px; font-size: 20px">
                            arrow_forward_ios
                        </span>
                    </span>
                </md-button>
            </span>
        </div>
        <vue-scroll>
            <newGroupMember
                v-for="user in searchUser"
                :key="user._id"
                :row="user"
                :on-select-member="() => selectMember(user)"
                :selectedMembers="selectedMembers"
            />
        </vue-scroll>
        <Modal2
            v-if="newGroupModalVisible && selectedMembers.length > 1"
            :title="$t('message.enterGroupTitle')"
            id="create-new-group"
            :show-footer="false"
            @cancel="newGroupModalVisible = false"
        >
            <a-input v-model="newGroupTitle" :placeholder="$t('message.title')" />
            <div v-if="!newGroupTitle" style="color: red; font-size: small">{{ $t("message.requiredTitle") }}</div>
            <div style="display: flex; justify-content: space-between; margin-top: 30px">
                <a-button class="add-segment-confirm-btn" @click="createNewGroup">
                    {{ $t("visitor.confirm") }}
                </a-button>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import newGroupMember from "./newGroupMember.vue";
import SendIcon from "../../../components/svg/SendIcon";
import { sendSocketMessage } from "../../../utils/socketStream";

const log = log2("addNewChat");
import Modal2 from "../../../components/common/Modal2";

export default {
    name: "addNewChat",
    props: {
        addNewUserGroupAgents: {
            type: Array,
            default: () => [],
        },
        addUserInGroup: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        newGroupMember,
        SendIcon,
        Modal2,
    },
    data() {
        return {
            selectedMembersIdx: [],
            selectedMembers: [],
            newGroupModalVisible: false,
            newGroupTitle: "",
            searchValue: "",
            searchUser: [],
        };
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            selectedChat: (state) => state.team.selectedChat,
            chats: (state) => state.team.chats,
        }),
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
            selectedChatChange: "team/selectedChatChange",
        }),

        async createChatOrAddUserGroup() {
            if (!!this.addUserInGroup) {
                this.selectedMembersIdx = this.selectedMembers.map((item) => item._id);
                sendSocketMessage("team add-user-group", {
                    siteId: this.site._id,
                    chat: this.selectedChat,
                    newAgentIds: this.selectedMembersIdx,
                });
            } else {
                if (this.selectedMembers.length > 1) {
                    this.newGroupModalVisible = true;
                } else {
                    await this.createNewThread();
                }
            }
        },

        selectMember(newMember) {
            const findMember = this.selectedMembers.findIndex((item) => item._id === newMember._id);
            if (findMember === -1) {
                this.selectedMembers = [...this.selectedMembers, newMember];
            } else {
                this.selectedMembers.splice(findMember, 1);
            }
        },
        cancelSelectMember(selectedMember) {
            this.selectedMembers.map((item) => {
                if (item._id === selectedMember._id) {
                    this.selectedMembers.splice(this.selectedMembers.indexOf(item), 1);
                }
            });
        },
        closeAddUserPage() {
            this.$emit("close");
        },
        async createNewGroup() {
            if (!this.newGroupTitle) {
                return;
            }
            this.selectedMembersIdx = this.selectedMembers.map((item) => item._id);
            const groupThread = {
                agents: this.selectedMembersIdx,
                title: this.newGroupTitle,
                creator: this.user._id,
            };
            sendSocketMessage("team group-chat-created", {
                siteId: this.site._id,
                groupThread,
                userId: this.user._id,
            });
            this.newGroupModalVisible = false;
        },

        async createNewThread() {
            this.selectedMembersIdx = this.selectedMembers.map((item) => item._id);

            const isChat = this.chats.filter((item) => {
                if (item.meta.chatType === "thread")
                    if (
                        (item.meta.thread.agent1._id === this.selectedMembersIdx[0] &&
                            item.meta.thread.agent2._id === this.user._id) ||
                        (item.meta.thread.agent2._id === this.selectedMembersIdx[0] &&
                            item.meta.thread.agent1._id === this.user._id)
                    ) {
                        return item;
                    }
            });

            if (isChat.length === 1) {
                await this.selectedChatChange(isChat[0]);
            } else {
                const thread = {
                    agent1: this.user._id,
                    agent2: this.selectedMembersIdx[0],
                };

                sendSocketMessage("team thread-chat-created", {
                    siteId: this.site._id,
                    thread,
                });
            }
        },
    },
    async mounted() {
        this.searchUser = this.users.filter((user) => user._id !== this.user._id);
        if (!!this.addUserInGroup) {
            this.searchUser = this.searchUser.filter((user) => !this.addNewUserGroupAgents.includes(user._id));
        }
    },
    watch: {
        searchValue(newVal) {
            this.searchUser = this.users.filter(
                (user) => user.name.toLowerCase().includes(newVal.toLowerCase()) && user._id !== this.user._id
            );
            if (!!this.addUserInGroup) {
                this.searchUser = this.searchUser.filter((user) => !this.addNewUserGroupAgents.includes(user._id));
            }
        },
    },
};
</script>

<style lang="scss">
#add-new-chat {
    width: 60%;

    .close-add-user-page {
        float: right;
        margin: 15px 15px 0 0;
        cursor: pointer;
    }

    .selected-user-input {
        padding: 30px 30px 30px 0;
        display: flex;
        align-items: center;
        margin-left: 15px;
        justify-content: space-between;

        .selected-user-item {
            background-color: #3c92de;
            padding: 5px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            margin-left: 5px;
            margin-right: 0px;
            color: white;

            .closeIcon {
                font-size: 15px;
                margin-left: 5px;
                color: white;
                cursor: pointer;
            }
        }

        .next-btn {
            color: #3c92de;
            display: flex;
            align-items: center;
        }

        .next-btn-disabled {
            color: #c4c4c4;
            display: flex;
            align-items: center;
        }

        .input-select {
            width: 200px;
            border-radius: 10px;
            border: 1px solid #3c92de;
            margin-left: 5px;
        }
    }
}
</style>
